/* oxlint-disable react/forbid-elements */
import { createIcon, type ISVGIconProps, type ISVGProps } from '@cian/ui-kit-design-tokens/internal';
import * as React from 'react';

const IconComponent = React.forwardRef((props: ISVGProps, ref: React.Ref<SVGSVGElement>) => {
  return (
    <svg {...props} ref={ref} width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#clip0)">
        <path
          d="M22.9999 4.91037C22.9999 3.8553 22.1045 3 20.9999 3H2.99994C1.89537 3 0.999939 3.8553 0.999939 4.91037V18.283C0.999939 19.3381 1.89537 20.1933 2.99994 20.1933H8.47734L12.0956 22.694L15.7204 20.1933H20.9999C22.1045 20.1933 22.9999 19.3381 22.9999 18.283V4.91037Z"
          stroke="currentColor"
          strokeWidth="2"
          strokeMiterlimit="10"
          strokeLinecap="square"
        />
        <path
          fill="currentColor"
          fillRule="evenodd"
          clipRule="evenodd"
          d="M10.9999 14.4506L10.9999 6.45056L12.9999 6.45056L12.9999 14.4506L10.9999 14.4506Z"
        />
        <path
          fill="currentColor"
          d="M11.9999 15.5494C11.4476 15.5494 10.9999 15.9972 10.9999 16.5494C10.9999 17.1017 11.4476 17.5494 11.9999 17.5494C12.5522 17.5494 12.9999 17.1017 12.9999 16.5494C12.9999 15.9972 12.5522 15.5494 11.9999 15.5494Z"
        />
      </g>
      <defs>
        <clipPath id="clip0">
          <rect width="24" height="24" fill="currentColor" transform="translate(0.867065)" />
        </clipPath>
      </defs>
    </svg>
  );
});

IconComponent.displayName = 'IconComplaints24';

export const IconComplaints24: React.FC<ISVGIconProps> = createIcon(IconComponent);
